import React, { Component } from "react";
import { Storage } from "aws-amplify";

class Image extends Component {
  loadInterval = false;
  state = {
    url: ""
  };

  componentDidMount() {
    const { picture } = this.props;
    this.loadInterval = setInterval(this.getFile(picture), 500);
  }

  componentWillUnmount() {
    this.loadInterval && clearInterval(this.loadInterval);
    this.loadInterval = false;
  }

  getFile = file => {
    Storage.get(file.key, {
      level: "public",
      bucket: file.bucket,
      region: file.region,
      identityId: file.identityId
    }).then(result => {
      this.loadInterval &&
        this.setState(() => {
          return { url: result };
        });
    });
  };

  render() {
    const { className } = this.props;
    return this.state.url ? (
      <img
        alt="example"
        resizemode="contain"
        className={className}
        src={this.state.url}
      />
    ) : (
      <div style={{ height: "40rem" }} />
    );
  }
}

export default Image;



// WEBPACK FOOTER //
// ./src/Components/Image/Image.js